import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Col, Row } from "react-bootstrap";
import "./AssociateModal.css";
import { FormattedMessage } from "react-intl";

function AssociateModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div>
        <Button className="asociar-modal-button" onClick={handleShow}>
          <FormattedMessage id="product-registration-modal-title" />
          {/* Asociar Sugerencia */}
        </Button>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="false"
          keyboard={false}
          centered
          className="dashboard-main-modal"
        >
          <Modal.Header closeButton className="dashboard-modal-closebutton">
            <Modal.Title className="dashboard-modal-title">
              <FormattedMessage id="product-registration-modal-title" />
              {/* Asociar sugerencia */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Row>
                <Col className="dashboard-modal-bold">
                  <FormattedMessage id="ready-size-clothing-type" />{" "}
                  <span className="dashboard-modal-fino">
                    <FormattedMessage id="ready-size-superior" />
                  </span>
                </Col>
              </Row>
              <Row>
                <Col className="dashboard-modal-bold">
                  <FormattedMessage id="ready-size-gender" />
                  <span className="dashboard-modal-fino">
                    <FormattedMessage id="ready-size-inferior" />
                  </span>
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default AssociateModal;
